import miniPlayer from './directives/mini-player';
import listScroll from './directives/list-scroll';
import chatScroll from './directives/chat-scroll';

export default Vue => {
  Vue.directive('mini-player', miniPlayer);
  Vue.directive('list-scroll', listScroll);
  Vue.directive('chat-scroll', chatScroll);
};
